const getAdjustedBaseColors = (oldPalette, newPalette) =>
  Object.keys(oldPalette.colors).filter(
    (colorKey) => oldPalette.colors[colorKey] !== newPalette.colors[colorKey]
  );

export default getAdjustedBaseColors;
